import ActionButton from './ActionButton'
import useStyles from './styles'
import IconVideoOn from 'components/UI/svgIcons/VideoOn'
import IconVideoOff from 'components/UI/svgIcons/VideoOff'
import IconMicOn from 'components/UI/svgIcons/MicOn'
import IconMicOff from 'components/UI/svgIcons/MicOff'
import IconChat from 'components/UI/svgIcons/Chat'
import Hangup from 'components/UI/svgIcons/Hangup'
import IconSettings from 'components/UI/svgIcons/Settings'
import { Observer } from 'mobx-react-lite'

const Actions = ({
  onSettingsClick,
  onChatClick,
  chatBadgeValue,
  onAudioClick,
  isAudioMuted,
  onVideoClick,
  isVideoMuted,
  onHangupClick,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.actions}>
      <Observer>
        {() => <ActionButton variant="settings" Icon={IconSettings} onClick={onSettingsClick} aria-label="Settings" />}
      </Observer>
      <Observer>
        {() => (
          <ActionButton
            badgeContent={chatBadgeValue}
            variant="chat"
            Icon={IconChat}
            onClick={onChatClick}
            aria-label={`Chat${chatBadgeValue ? `, ${chatBadgeValue} messages` : ''}`}
          />
        )}
      </Observer>

      <Observer>
        {() => (
          <ActionButton
            variant="audio"
            Icon={isAudioMuted ? IconMicOff : IconMicOn}
            onClick={onAudioClick}
            aria-label={`Microphone is ${isAudioMuted ? 'off' : 'on'}. Click here to toggle microphone`}
          />
        )}
      </Observer>
      <Observer>
        {() => {
          return (
            <ActionButton
              variant="video"
              Icon={isVideoMuted ? IconVideoOff : IconVideoOn}
              onClick={onVideoClick}
              aria-label={`Camera is ${isVideoMuted ? 'off' : 'on'}. Click here to toggle camera`}
            />
          )
        }}
      </Observer>
      <ActionButton variant="hangup" Icon={Hangup} onClick={onHangupClick} aria-label="Hangup" />
    </div>
  )
}

export default Actions
